module.exports = __webpack_public_path__ + "img/Update-pana.5e181fcc.svg";